import { useController } from 'react-hook-form';

/**
 * Hook per la gestione di un campo di un form.
 * È possibile usare field.onChange per modificare il valore del campo.
 */
export function useFormField(name: string) {
  const { field } = useController({ name });

  return field;
}
